import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { useHistory } from "react-router-dom";
import { Box } from "@material-ui/core";
import ContactActivityItemTimeLine from "../ContactActivityItemTimeLine/ContactActivityItemTimeLine";
import {
  ContactActivityItemTimeLineSkeleton,
  CustomPagination,
  NoDataFound,
} from "../../../../../../Components";
import { GetAllActivities } from "../../../../../../Services";
import { AddNewActivityModalDialog } from "../../../../../../Components/V2/Header/UI/AddQuickActivityRelatedDialogs/AddNewActivityModalDialog";
import { useQuery } from "../../../../../../Hooks";

// Styles
import useStyles from "./styles";

const ContactActivities = forwardRef(({ contactId , contactWithPolicy}, ref) => {
  const styles = useStyles();
  const query = useQuery();
  const history = useHistory();

  const [pagination, setPagination] = useState({
    contactId: +query.get("id"),
    pageSize: parseInt(localStorage.getItem("Pagination")) || 25,
    pageIndex: 0,
    search: "",
    leadId: null,
    orderBy: 1,
    filterBy: "ActivityDate",
    userId: "",
  });
  const [inputValue, setInputValue] = useState(pagination.pageIndex);
  const [activities, setActivities] = useState({
    result: [],
    totalCount: 0,
  });
  const [DialogSelect, setDialogSelect] = useState("");
  const [isOpenDialog, setisOpenDialog] = useState({
    ActivitiesDialog: "",
  });
  const [isLoadings, setIsLoadings] = useState({
    allAgentsLoading: false,
    allLeadsLoading: false,
    allActivitiesLoading: false,
  });

  const getAllActivities = useCallback(async () => {
    setIsLoadings((loading) => ({ ...loading, allActivitiesLoading: true }));
    const res = await GetAllActivities({
      contactId: pagination.contactId,
      pageSize: pagination.pageSize,
      pageIndex: pagination.pageIndex + 1,
      orderBy: pagination.orderBy,
      isWithoutRelatedActivities: false,
      filterBy: pagination.filterBy,
      search: pagination.search || "",
      guidAgentId: pagination.userId,
      relatedLeadId: pagination.leadId,
    });
    if (!(res && res.status && res.status !== 200)) {
      setActivities({
        result: (res && res.result) || [],
        totalCount: (res && res.totalCount) || 0,
      });
    } else {
      setActivities({
        result: [],
        totalCount: 0,
      });
    }
    setIsLoadings((loading) => ({ ...loading, allActivitiesLoading: false }));
  }, [pagination]);

  useImperativeHandle(ref, () => ({
    handleAddActivityContact: () => {
      setisOpenDialog((item) => ({ ...item, ActivitiesDialog: true }));
    },
  }));
  useEffect(() => {
    getAllActivities();
  }, [pagination]);

  useEffect(() => {
    // Clear the state when contactId changes (or navigate without the state)
    history.replace({
      pathname: history.location.pathname, // Keep the current path
      search: history.location.search, // Retain query parameters like ?formType=1&id=...
      // No state to pass here, effectively clearing it
      // in order to reset to the initial tab in contact overview page
    });
  }, [contactId, history]); // This effect is triggered when contactId changes

  return (
    <Box className={styles.container_Contact_Activity}>
      {isLoadings.allActivitiesLoading ? (
        <ContactActivityItemTimeLineSkeleton numberSkeletonCard={8} />
      ) : activities?.result?.length > 0 ? (
        <Box className={styles.container_timeLine_Crad}>
          <ContactActivityItemTimeLine
            timelineItems={activities?.result}
            totalCount={activities?.totalCount}
            contactWithPolicy={contactWithPolicy}
          />
        </Box>
      ) : (
        <NoDataFound title={"activites"} />
      )}

      {activities?.result?.length > 0 && (
        <CustomPagination
          hideInMobile
          totalItems={activities?.totalCount}
          itemsPerPage={pagination?.pageSize}
          currentPage={pagination?.pageIndex}
          inputValue={inputValue}
          setInputValue={setInputValue}
          onPageChange={(page) =>
            setPagination((prev) => ({ ...prev, pageIndex: page }))
          }
          onItemsPerPageChange={(items) =>
            setPagination((prev) => ({ ...prev, pageSize: items }))
          }
          isLoading={isLoadings.isContactActivitesLoading}
        />
      )}
      {isOpenDialog.ActivitiesDialog && (
        <AddNewActivityModalDialog
          isEdit={false}
          isGeneralDialog
          activeItem={null}
          setDialogSelect={setDialogSelect}
          DialogSelect={DialogSelect}
          setisOpenDialog={setisOpenDialog}
          onOpen={isOpenDialog.ActivitiesDialog}
          onClose={() => {
            setisOpenDialog((item) => ({ ...item, ActivitiesDialog: false }));
            setDialogSelect("");
          }}
        />
      )}
    </Box>
  );
});

export default ContactActivities;
